import React from 'react';

import type { Asset2Tag } from '../../../../apis/graphql';

/**
 * Displays the AssetTags segment
 */
export const AssetTags: React.FC<{ tagList?: Asset2Tag[] | null }> = (props) => {
  if (!props.tagList?.length) return null;

  const formattedTags = props.tagList?.map((tag) => tag.displayName).join(', ');

  return (
    <>
      {' '}
      | <strong>Tags:</strong> {formattedTags}
    </>
  );
};
